// Opening one account (A4) and coming back from it. Back returns to where the
// admin came from, Accounts with the same search and place, or Subscriptions
// (A6), so the list is kept mounted underneath and its scroll is remembered.

import type { components } from '../api/types';
import { navigate } from '../router.svelte';

type AccountRow = components['schemas']['AdminAccountRowBody'];

export type AccountOrigin = '/accounts' | '/subscriptions';

let origin = $state<AccountOrigin>('/accounts');
let scrolledTo = 0;

/** The path of an account's page. */
export function accountPath(accountId: string): string {
	return `/accounts/${encodeURIComponent(accountId)}`;
}

/** The account id a path names, or empty when it names none. */
export function accountIdOf(path: string): string {
	const match = /^\/accounts\/([^/]+)$/.exec(path);
	return match?.[1] ? decodeURIComponent(match[1]) : '';
}

export function openAccount(accountId: string, from: AccountOrigin = '/accounts'): void {
	origin = from;
	scrolledTo = window.scrollY;
	navigate(accountPath(accountId));
	window.scrollTo(0, 0);
}

export function accountOrigin(): AccountOrigin {
	return origin;
}

export function backFromAccount(): void {
	navigate(origin);
	const y = scrolledTo;
	requestAnimationFrame(() => window.scrollTo(0, y));
}

// An account changed on its own page. The kept list replaces that row, so
// Back shows the state the admin just set without losing the search or More.
let changedRow = $state<AccountRow | null>(null);

export function accountChanged(row: AccountRow): void {
	changedRow = row;
}

export function lastChangedAccount(): AccountRow | null {
	return changedRow;
}
